<template>
  <div class="leading-normal">
    <div v-if="categoryName === 'Refined Magazine' || categoryName === 'Exclusive Home Worldwide Magazine'">
      <Reference :orderItem="orderItem" :fullWidth=true />
      <Notifications :orderItem="orderItem" :fullWidth=true @addCc="addCc" @removeCc="removeCc" />
      <Notes :orderItem="orderItem" />
    </div>
    <div v-else-if="categoryName === 'Stock Items'">
      <Reference :orderItem="orderItem" :fullWidth=true />
      <Notifications :orderItem="orderItem" :fullWidth=true @addCc="addCc" @removeCc="removeCc" />
    </div>
    <div v-else class="w-full flex flex-wrap mb-6">
      <div class="w-full pb-6 md:w-1/2 md:pr-4 md:pb-0 md:border-r">
        <Reference :orderItem="orderItem" :fullWidth=false />
        <Notifications :orderItem="orderItem" :fullWidth=false @addCc="addCc" @removeCc="removeCc" />
        <Notes :orderItem="orderItem" />
      </div>
      <div class="w-full md:w-1/2 md:pl-4">
        <div>
          <h3 class="mb-2">File Upload <span class="text-sm font-normal">(if required)</span></h3>
          <p v-if="fineAndCountry" class="mb-4">Add any useful files such as headshots, if applicable to your order.</p>
          <div v-else>
            <p class="mb-4">Add any useful files such as headshots or examples that you would like us to use, or take inspiration from, when creating your item.</p>
            <p class="mb-4"><strong>Important:</strong> if you chose to supply your own artwork, upload your print-ready file here. Ensure that your print-ready file includes:</p>
            <ul class="mb-3">
              <li class="mb-1">3mm crops and bleed marks</li>
              <li class="mb-1">No images/text within 5mm of the edge of the file</li>
              <li class="mb-1">High resolution imagery (preferably over 1MB)</li>
            </ul>
            <p class="mb-4">Your print-ready file will be checked and proofed back to you before it is sent to print.
              If it does not meet our printer's requirements, we will inform you of the changes required.
              Alternatively, we can make the changes on your behalf, which is chargeable depending on the size of the job.</p>
          </div>
          <div id="cpo-dropzone" class="border border-dashed rounded-lg mb-4 py-6 px-4">
            <div v-if="orderItem.attachments && orderItem.attachments.length > 0 || orderItem.uploads && orderItem.uploads.length > 0" class="w-full border-bottom border-dashed mb-6 pb-4">
              <table>
                <tbody>
                  <tr v-for="(file, i) in orderItem.attachments.filter(file => !file.is_qr_code)" :key="i" class="h-12">
                    <td class="inline-block w-12 h-12 mr-2 my-1">
                      <img :src="file.thumb" :alt="file.filename" loading="lazy" class="block w-12 min-h-8 h-full bg-grey-lighter object-contain" />
                    </td>
                    <td class="w-full">{{ file.filename }}</td>
                    <td>
                      <i class="fas fa-check-circle text-print-order-teal fa-2x pl-2"></i>
                    </td>
                    <td>
                      <i class="fas fa-trash-alt text-grey fa-2x pl-2 cursor-pointer" @click="deleteAsset(file)"></i>
                    </td>
                  </tr>
                  <tr v-for="(file, i) in orderItem.uploads.filter(file => !file.is_qr_code)" :key="100 + i" class="h-12">
                    <td class="inline-block w-12 h-12 inline-block mr-2 my-1">
                      <div class="block w-12 min-h-8 h-full bg-grey-lighter object-contain"></div>
                    </td>
                    <td class="w-full">{{ file.filename }}</td>
                    <td>
                      <i v-if="file.complete" class="fas fa-check-circle text-print-order-teal fa-2x pl-2"></i>
                      <gauge-graph v-else :series="[{ color: '#eee', value: 101 },{ color: '#0d9eff', value: file.progress }]" :maximum="101" :arc-size="360" :offset="0" class="w-8 h-8">
                      </gauge-graph>
                    </td>
                    <td>
                      <i class="fas fa-trash-alt text-grey fa-2x pl-2 cursor-pointer" @click="deleteAsset(file)"></i>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <upload-dropzone @change="uploadFiles($event, false)" accept="png" containerClass="pb-2" />
          </div>
        </div>
        <div>
          <h3 class="mb-2">QR Code Upload <span class="text-sm font-normal">(optional)</span></h3>
          <p v-if="fineAndCountry" class="mb-4">Add any useful QR code files, if applicable to your order.</p>
          <div v-else>
            <p class="mb-4">Add any useful QR code files that you would like us to use, or take inspiration from, when creating your item.</p>
            <p class="mb-4"><strong>Important:</strong> if you chose to supply your own artwork, upload your print-ready file here. Ensure that your print-ready file includes:</p>
          </div>
          <div id="cpo-dropzone" class="border border-dashed rounded-lg mb-4 py-6 px-4">
            <div v-if="orderItem.attachments && orderItem.attachments.length > 0 || orderItem.uploads && orderItem.uploads.length > 0" class="w-full border-bottom border-dashed mb-6 pb-4">
              <table>
                <tbody>
                  <tr v-for="(file, i) in orderItem.attachments.filter(file => file.is_qr_code)" :key="i" class="h-12">
                    <td class="inline-block w-12 h-12 mr-2 my-1">
                      <img :src="file.thumb" :alt="file.filename" loading="lazy" class="block w-12 min-h-8 h-full bg-grey-lighter object-contain" />
                    </td>
                    <td class="w-full">{{ file.filename }}</td>
                    <td>
                      <i class="fas fa-check-circle text-print-order-teal fa-2x pl-2"></i>
                    </td>
                    <td>
                      <i class="fas fa-trash-alt text-grey fa-2x pl-2 cursor-pointer" @click="deleteAsset(file)"></i>
                    </td>
                  </tr>
                  <tr v-for="(file, i) in orderItem.uploads.filter(file => file.is_qr_code)" :key="100 + i" class="h-12">
                    <td class="inline-block w-12 h-12 inline-block mr-2 my-1">
                      <div class="block w-12 min-h-8 h-full bg-grey-lighter object-contain"></div>
                    </td>
                    <td class="w-full">{{ file.filename }}</td>
                    <td>
                      <i v-if="file.complete" class="fas fa-check-circle text-print-order-teal fa-2x pl-2"></i>
                      <gauge-graph v-else :series="[{ color: '#eee', value: 101 },{ color: '#0d9eff', value: file.progress }]" :maximum="101" :arc-size="360" :offset="0" class="w-8 h-8">
                      </gauge-graph>
                    </td>
                    <td>
                      <i class="fas fa-trash-alt text-grey fa-2x pl-2 cursor-pointer" @click="deleteAsset(file)"></i>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <upload-dropzone @change="uploadFiles($event,true)" accept="png" containerClass="pb-2" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import api, { v2Api } from '@/http'
import http from 'axios'
import { mapActions, mapState } from 'vuex'
import Notes from '../new-order/stage-1/Notes.vue'
import Notifications from '../new-order/stage-1/Notifications.vue'
import Reference from '../new-order/stage-1/Reference.vue'
import GaugeGraph from '@/components/Graphs/GaugeGraph'
import UploadDropzone from '@/components/UploadDropzone'

export default {
  data () {
    return {
      name: 'Custom Print Order',
      addressModalOpen: false,
      ccEmail: null
    }
  },
  components: {
    Notes,
    Notifications,
    Reference,
    GaugeGraph,
    UploadDropzone
  },
  props: ['orderItem', 'errorBag', 'officeId', 'categoryName', 'fineAndCountry'],
  computed: {
    ...mapState(['profile'])
  },
  created () {
  },
  methods: {
    ...mapActions(['displayToastNotification']),
    addCc (recipient) {
      this.$emit('addCc', recipient)
    },
    removeCc (recipient) {
      this.$emit('removeCc', recipient)
    },
    uploadFiles (files, isQrCode) {
      for (let i = 0; i < files.length; i++) {
        this.uploadFile(files[i], isQrCode)
      }
    },
    async uploadFile (file, isQrCode) {
      // validate image type
      let isImage = false
      if (file.type === 'image/png' || file.type === 'image/jpeg' || file.type === 'image/tiff') {
        isImage = true
      }
      if (isImage && (file.size / 1000) < 500 && !isQrCode) {
        return this.displayToastNotification({
          type: 'danger',
          icon: 'fa-times-circle',
          title: 'Error',
          info: 'File uploads need a file size of at least 500kB to ensure image quality'
        })
      }
      let attachment = {
        filename: file.name,
        size: file.size,
        progress: 0,
        complete: false,
        is_qr_code: isQrCode
      }
      this.orderItem.uploads.push(attachment)

      let filePath = `custom-print-orders/${this.officeId}`

      const extension = file.name.split('.').pop()
      const response = await api.post('signed-upload', {
        'disk': 's3',
        'extension': extension,
        'path': filePath,
        'visibility': 'public-read',
        'content_type': file.type
      })

      let s3File = response.data.key
      let headers = response.data.headers
      if ('Host' in headers) {
        delete headers.Host
      }

      await http.put(response.data.url, file, {
        headers: headers,
        onUploadProgress: (progressEvent) => {
          attachment.progress = Math.ceil(progressEvent.loaded / progressEvent.total * 100)
        }
      })

      let data = {
        office_id: this.officeId,
        file_path: s3File,
        file_name: file.name,
        is_qr_code: isQrCode
      }

      if (this.orderItem.id) {
        data.item_id = this.orderItem.id
      }

      v2Api.post('custom-print-order-attachments', data).then((response) => {
        attachment.complete = true
        this.orderItem.attachments.push(response.data.attachment)
        this.orderItem.uploads.splice(this.orderItem.uploads.indexOf(attachment), 1)
      }, (errors) => {
        this.orderItem.uploads.splice(this.orderItem.uploads.indexOf(attachment), 1)
        this.displayToastNotification({
          type: 'danger',
          icon: 'fa-times-circle',
          title: 'Error',
          info: errors.response.data.errors
        })
      })
    },
    deleteAsset (file) {
      if (confirm('Are you sure you would like to delete the file upload?')) {
        this.orderItem.uploads = this.orderItem.uploads.filter(attachment => attachment.id !== file.id)
        if (this.orderItem.attachments.filter(attachment => attachment.id === file.id).length > 0) {
          v2Api.delete(`custom-print-order-attachments/${file.id}`).then((response) => {
            this.orderItem.attachments = this.orderItem.attachments.filter(attachment => attachment.id !== file.id)
          })
        }
      }
    }
  }
}
</script>

<style lang="sass">
#cpo-dropzone
  h3
    @apply font-normal text-sm
  label
    @apply bg-blue text-white
</style>
